import React from 'react'
import { Heading } from "@chakra-ui/react"

const TitleSpoleto = ({ children, ...rest }) => {
	return (
		<Heading
			color="#FDF6DC"
			textAlign="center"
			fontSize={['30px', null, '48px']}
			fontFamily="JosefinBold"
			textTransform="uppercase"
			{...rest}
		>
			{children}
		</Heading>
	)
}

export default TitleSpoleto
